import { Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import ExtendedForecast from './ExtendedForecast/ExtendedForecast';
import ForecastByMunicipalities from './ForecastByMunicipalities/ForecastByMunicipalities';


const useStyles = makeStyles((theme) => ({
    divider: {
        marginBottom: theme.spacing(5),
        marginTop: theme.spacing(5),
    },
}));

function Forecast() {
    const classes = useStyles();
    return (
        <div>
            <ExtendedForecast />
            <Divider className={classes.divider} />
            <ForecastByMunicipalities />
        </div>
    )
}

export default Forecast;
